import { IntroSectionData } from "../../../types/IntroSectionData";
import Img0 from '../../../assets/images/itm-11.png';
import Img1 from '../../../assets/images/itm-5.png';
import Img2 from '../../../assets/images/itm-10.png';
import Img3 from '../../../assets/images/itm-4.png';
import Img4 from '../../../assets/images/itm-8.png';

const introSectionData0: IntroSectionData = {
  sectionTitle: "Expertise",
  sectionSubtitle: "Déploiement applicatif.",
  tabsData: [
    {
      id: 0,
      title: "Maîtrise",
      heading: "Maîtrise des architectures applicatives modernes",
      text: "Nous maîtrisons les différents types d'architectures applicatives, des applications traditionnelles aux architectures microservices et serverless. Nous vous conseillons sur le choix de l'architecture la plus adaptée.",
    },
    {
      id: 1,
      title: "Orchestration",
      heading: "Expertise des plateformes de conteneurisation et d'orchestration",
      text: "Nous sommes experts dans l'utilisation des technologies de conteneurisation et des plateformes d'orchestration. Nous packageons vos applications dans des conteneurs pour les rendre portables, légères et faciles à déployer dans différents environnements cloud.",
    },
    {
      id: 2,
      title: "Intégration",
      heading: "Intégration continue et déploiement continu (CI/CD)",
      text: "Nous mettons en place des pipelines performants pour automatiser l'ensemble du processus de développement et de déploiement de vos applications. Nous configurons des tests automatisés à chaque étape du pipeline pour garantir la qualité et la fiabilité de vos applications.",
    },
    {
      id: 3,
      title: "Sécurité",
      heading: "Sécurité dans le déploiement d'applications cloud",
      text: "La sécurité est une priorité absolue lors du déploiement de vos applications dans le cloud. Nous implémentons des mesures de sécurité robustes pour protéger vos applications et vos données. Nous configurons des contrôles d'accès stricts, des règles de pare-feu, des passerelles API sécurisées.",
    },
  ],
  fixedImageSrc: Img0,
  fixedImageAlt: "IT Monkeys Cloud Cyber",
};

export default introSectionData0;